import { render, staticRenderFns } from "./POBTab.vue?vue&type=template&id=0237b606"
import script from "./POBTab.vue?vue&type=script&lang=js"
export * from "./POBTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports